import React, {Fragment, useRef, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'

const Input: (props: any) => JSX.Element = (props: any) => {

    const [empty, setEmpty] = useState<boolean>(true);
    const input = useRef<any>(null);
    const {id, label, name, type, required, className, defaultValue, onBlur} = props;

    const handleClick = () => {
        input.current!.focus();
    }

    const handleChange = () => {
        const value = input.current!.value;
        setEmpty(value === '');
    }

    const handleBlur = () => {
        if(onBlur) {
            onBlur();
        }
    }

    return (
        <Fragment>
            <div className={`flex flex-row ${type === 'textarea' ? 'items-start' : 'items-center'} gap-5 w-[100%] transition-all bg-white border-[1px] ${empty ? 'border-gray-500 text-gray-500' : 'border-grey-800 text-gray-800'}`} onClick={() => handleClick()} >
                <div className={`px-5 border-r-[1px] ${empty ? 'border-r-gray-300' : 'border-r-gray-500'} ${type === 'textarea' ? ' mt-3' : ''}`} >
                    <FontAwesomeIcon icon={icon({name: 'arrow-right-long'})} />
                </div>
                {type === 'textarea' ?
                    <textarea ref={input} id={id} name={name} className={`w-full outline-0 h-[10rem] py-3${className ? ` ${className}` : ''}`} required={required} placeholder={label} defaultValue={defaultValue} onBlur={() => handleBlur()} onChange={() => handleChange()}></textarea>
                    :
                    <input ref={input} id={id} type={type ? type : 'text'} name={name} className={`w-full outline-0 py-3${className ? ` ${className}` : ''}`} placeholder={label} required={required} defaultValue={defaultValue} onBlur={() => handleBlur()} onChange={() => handleChange()} />
                }
            </div>
        </Fragment>
    );
}

export default Input;
